<template>
  <div>
    <select-input :id="id" ref="input" v-model="selected" v-bind="$attrs" :class="{ error: error }"
                  :label="label">
      <option :value="option.value" v-for="(option, key) in options" v-bind:key="key">{{option.label}}</option>
    </select-input>
    <div v-if="error" className="form-error">{{ error }}</div>
  </div>
</template>
<script>

import SelectInput from './SelectInput'

export default {
  name: 'SelectLanguage',
  components: {SelectInput},
  props: {
    id: {
      type: String,
    },
    value: [String, Number, Boolean],
    label: String,
    error: String,
  },
  data() {
    return {
      selected: this.value,
      options: this.$languages.getLanguages(),
    }
  },
  watch: {
    selected(selected) {
      this.$emit('input', selected)
    },
  },
  methods: {
    focus() {
      this.$refs.input.focus()
    },
    select() {
      this.$refs.input.select()
    },
  },
}
</script>

<style scoped>

</style>
